import { callTool } from "@/lib/agents/playbooks"

const MATH = /^[\d\s.+\-*/()]+$/
const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const fakeAI: PlaybookAI = async (run, call) => {
  const message = run.input.message || ""
  const text = message.trim().toLowerCase()
  const calls: PlaybookToolCall[] = []
  const written: string[] = []

  async function invoke(name: string, args: any, result: (args: any) => any, delay = 0) {
    const value = await callTool(run, name, args, async args => {
      if (delay) await sleep(delay)
      return result(args)
    })
    calls.push({ name, args, result: value })
    return value
  }

  const tool = (name: string, args: any) => invoke(name, args, args => call.tools?.find(t => t.name === name)?.run?.(args, run))

  await sleep(400)
  for (const t of call.tools || []) {
    if (t.name.startsWith("save_")) await tool(t.name, { value: message })
    if (t.name.startsWith("reference_")) await tool(t.name, {})
    if (t.name === "calculate" && MATH.test(text)) await tool(t.name, { expression: text })
    if (t.name === "note_write") await tool(t.name, { scope: "item", key: "last_message", text: message })
  }

  const counters = { search: 0, generate: 0, pdf: 0 }
  for (const config of call.platform || []) {
    const name = `${config.type}_${++counters[config.type as keyof typeof counters]}`
    if (config.type === "search") {
      const count = config.sources.reduce((n, s) => n + (s.results || 3), 0) || 3
      await invoke(name, { query: message }, () => Array.from({ length: count }, (_, i) => `Title: Fake result ${i + 1}\nContent: Something about "${message}"`), 800)
    }
    if (config.type === "generate") written.push(await invoke(name, { brief: message }, () => `[generate] a text about "${message}"`, 800))
    if (config.type === "pdf") await invoke(name, { title: message, markdown: `# ${message}` }, () => "The PDF was sent.", 800)
  }

  const transition = text.length > 2 && call.tools?.find(t => t.transition && t.description.toLowerCase().includes(text))
  if (transition) calls.push({ name: transition.name, args: {} })
  const reply = transition ? `[${call.model}] calling ${transition.name}.` : `[${call.model}] answering "${message}". Say "menu" to go back.`
  return { text: [reply, ...written].join("\n\n"), transition: transition ? transition.name : undefined, calls: calls.length ? calls : undefined }
}
